import { render, staticRenderFns } from "./InformationTabOverviewCard.vue?vue&type=template&id=17b11dba&scoped=true&"
import script from "./InformationTabOverviewCard.vue?vue&type=script&lang=ts&"
export * from "./InformationTabOverviewCard.vue?vue&type=script&lang=ts&"
import style0 from "./InformationTabOverviewCard.vue?vue&type=style&index=0&id=17b11dba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b11dba",
  null
  
)

export default component.exports